module.exports = __webpack_public_path__ + "static/media/devotional.21494d8e.jpeg";